import { planName } from '@/shared/config/plans';
import type { PlanId } from '@/shared/types/workspace';

export const planLabel = (plan: PlanId): string => `${planName(plan)} plan`;

/** The workspace's avatar letter. */
export const workspaceInitial = (name: string): string =>
  name.trim().charAt(0).toUpperCase() || 'M';

export const hasConnectedAgent = (statuses: readonly string[]): boolean =>
  statuses.some((status) => status === 'CONNECTED' || status === 'KEY_REJECTED');
